<template>
    <div class="heading-wrapper">
        <h2 data-aos="fade-in">{{title}}</h2>
        <h3 data-aos="fade-in">{{subtitle}}</h3>
        <slot name="subtitle"></slot>
    </div>
</template>

<script>
export default {
    props : {
        title: String,
        subtitle: String
    }
}
</script>


<style lang="scss" scoped>
    .heading-wrapper {
        margin-bottom: 3rem;
        font-family: 'Macondo Swash Caps', cursive;
        h2 {
            display: inline-block;
            margin-bottom: 0;
            color: #e74c3c;
            font-size: 3.3em;
            font-weight: bold;
        }
    }
</style>
